// extracted by mini-css-extract-plugin
export var alignCenter = "_9u-d";
export var bannerShown = "_9u-6";
export var buttonContent = "_9u-0";
export var cardList = "_9u-1";
export var centerContent = "_9u-2";
export var chevron = "_9u-3";
export var closePanelButton = "_9u-k";
export var conversationContextContainer = "_9u-l";
export var conversationDetailContainer = "_9u-4";
export var detailWrapper = "_9u-7";
export var dropdownButton = "_9u-e";
export var dropdownTitle = "_9u-9";
export var fullHeight = "_9u-5";
export var hidden = "_9u-a";
export var icon = "_9u-b";
export var mergeSuggestionWrapper = "_9u-m";
export var panel = "_9u-i";
export var portalButtonsWrapper = "_9u-c";
export var right = "_9u-j";
export var tableSummaryContainer = "_9u-8";
export var tableSummaryHeader = "_9u-g";
export var threeDotsButton = "_9u-f";
export var wide = "_9u-h";